<style lang="scss">
.cm-tabs {
    height: calc(100% - 0px);
    display: flex;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;

    /* IE 10+ */
    ::-webkit-scrollbar {
        display: none;
        /* Chrome Safari */
    }

    .cm-tabs-scroll-view {
        position: relative;
        -webkit-overflow-scrolling: touch;
        width: 100%;
        height: 100%;
        max-height: inherit;

        .cm-tabs-scroll_content {
            height: calc(100% - 0px);
            overflow-y: auto;
            position: relative;
            -webkit-overflow-scrolling: touch;
            width: 100%;
            max-height: inherit;
            margin-bottom: 100px;

        }
    }

    .cm-tabs-bar {
        background: #fff;

        .cm-tabs-bar_item {
            width: 100%;
            min-height: 2.3rem;
            background: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-weight: 400;
            font-size: .875rem;
            color: #9b9fa8;
            transition: all 0.3s ease;
            position: relative;

            .cm-tab__texts {
                font-size: 0.70rem;
                text-align: left;
                margin-left: 10px;
                color: #676767;
            }



            &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 2px;
                /* Adjust this value based on your design */
                width: 0%;
                height: 2px;
                /* Thickness of the border */
                background-color: var(--main-color);
                transition: width 0.5s ease-in-out;
            }
        }

        .active::after {
            width: 100%;
        }

        .cm-tabs-body_scroll {
            height: calc(100% - 0px);
            overflow-y: auto;
        }
    }

    .cm-tabs-body {
        padding: 0px 10px;
    }

}
</style>
<template>
    <div class="cm-tabs" ref="cmTabs">
        <div class="cm-tabs-scroll-view cm-tabs-bar" :style="getStyle">
            <div class="cm-tabs-scroll_content" ref="scrollBar">
                <div :class="{ 'cm-tabs-bar_item': true, 'active': activeName == item[props.key] }"
                     v-for="(item, index) in data" :key="index" :tab="item[props.key]"
                     :data-tab-id="(index + '-' + item[props.key])"
                     @click="changeTab(item[props.key], item, (index + '-' + item[props.key]))">
                    <span class="cm-tab__texts">{{ item[props.title] }}</span>
                </div>
            </div>
        </div>
        <div class="cm-tabs-scroll-view cm-tabs-body">
            <div class="cm-tabs-scroll_content" ref="scrollContent">
                <div class="cm-tabs-body_content">
                    <div class="cm-tabs-body_item" v-for="(item, index) in data" :key="index"
                         :data-tab-key="item[props.key]" :data-tab-row="item"
                         :data-tab-index="(index + '-' + item[props.key])"
                         @mousewheel="(e) => tabItemScrollChange(e, item[props.key], item, (index + '-' + item[props.key]))"
                         :ref="`bodyItem[${index}]`">
                        <slot name="default" :row="item" :rowIndex="index" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cm-tabs',
    data() {
        return {
            topShow: false,
            activeName: 0,
            needTime: 0,
            init: false,
        };
    },
    props: {
        value: {
            type: [String, Number],
            required: true,
            default: 0
        },
        tabWidth: {
            type: [String, Number],
            required: false,
            default: 100
        },
        tabPosition: {
            type: String,
            required: false,
            default: 'top'
        },
        data: {
            type: [Array],
            required: true,
            default: '#topAnchor'
        },
        props: {
            type: [Object],
            required: false,
            default: {
                title: 'title',
                key: 'key',
            }
        }
    },
    watch: {
        'value': {
            handler() {
                this.$nextTick(() => {
                    if (!this.init) {
                        this.setNowActive();
                    }
                    this.init = true
                })
            },
            immediate: true
        }
    },
    mounted() {

    },
    computed: {
        getStyle() {
            if ('number' === typeof this.tabWidth) {
                return {
                    width: this.tabWidth + 'px',
                    minWidth: this.tabWidth + 'px',
                }
            }
            return {
                width: this.tabWidth,
                minWidth: this.tabWidth,
            }
        }
    },
    methods: {
        setNowActive() {
            if (this.needTime < 2000) {
                setTimeout(() => {
                    if (this.data && this.data.length > 0) {
                        this.data.forEach((item, index) => {
                            if (item[this.props.key] == this.value) {
                                this.changeTab(this.value, item, index + '-' + this.value);
                            }
                        });
                    }
                    else {
                        this.needTime = this.needTime + 10
                        this.setNowActive()
                    }
                }, 10)
            }

        },
        tabEventListener() {
            this.$nextTick(() => {
                setTimeout(() => {
                    var els = document.querySelectorAll("[tab-data-index]");
                    console.log('els', els);
                    window.addEventListener("scroll", this.init); //监听页面滚动
                }, 10)
            });
        },
        tabItemScrollChange(e, key, row, id) {
            this.setScrollNowEl();
        },
        setScrollNowEl() {
            // content层卷去的高度
            let scrollTop = this.getScrollTop(this.$refs.scrollContent);
            // 所有item元素
            let itemEls = document.querySelectorAll("[data-tab-index]");
            if (itemEls && itemEls.length) {
                let height = 0;
                let findEl = false;
                itemEls.forEach((element, index) => {
                    if (!findEl && height >= scrollTop) {
                        findEl = true;
                        if (element.dataset && element.dataset.tabKey) {
                            this.changeTab(element.dataset.tabKey, element.dataset.tabRow, element.dataset.tabIndex, false);
                        }
                        // console.log('已满足', [element]);
                    }

                    if (!findEl) {
                        height += element.offsetHeight
                    }

                });
            }
        },
        changeTab(value, row, id, scroll = true) {
            this.setScrollTop(id, scroll);
            this.activeName = value
            this.$emit('change', {
                value: value,
                row: row
            });

        },
        setScrollTop(id, scroll) {
            let elBar = document.querySelector("[data-tab-id='" + id + "']");
            let scrollTop = elBar.offsetTop - this.$refs.cmTabs.offsetHeight / 2 + elBar.offsetHeight / 2;
            // 滚动tab层
            this.toTop(this.$refs.scrollBar, scrollTop)
            if (scroll) {
                let elItem = document.querySelector("[data-tab-index='" + id + "']");
                // 滚动content层
                this.toTop(this.$refs.scrollContent, elItem.offsetTop - 10)
            }
        },
        getScrollTop(el) {
            return el.pageYOffset || el.scrollTop;
        },
        // 滚动指定元素到指定未知
        toTop(el, scrollTopEnd) {
            // if (scrollTopEnd <= 0) {
            //     return;
            // }
            // 距离顶部距离
            var scrollTop = parseFloat(this.getScrollTop(el))
            // console.log('scrollTopEnd', scrollTopEnd);
            // 最多花费时间
            var max_time = 200;
            // 循环定时器指针
            var Interval = null;
            // 执行周期时间
            var interval_time = 10;
            // 已花时间 
            var time = 0;
            // 平均速度
            var speed = Math.abs(parseFloat((scrollTopEnd - scrollTop) / max_time * interval_time));
            // console.log('speed', speed, 'scrollTop', scrollTop);
            let nowOffset = scrollTop;
            Interval = setInterval(() => {
                time += interval_time
                if (time >= max_time) {
                    nowOffset = scrollTopEnd;
                } else {
                    // nowOffset = parseFloat(parseFloat(nowOffset + speed).toFixed(2))
                    if (scrollTopEnd > scrollTop) {
                        nowOffset = parseFloat(parseFloat(nowOffset + speed).toFixed(2))
                    }
                    else {
                        nowOffset = parseFloat(parseFloat(nowOffset - speed).toFixed(2))
                    }
                }

                try {
                    el.scrollTo(0, nowOffset)
                } catch (error) {
                    console.log('移动到指定scrollTop出错, ' + error);
                    clearInterval(Interval)
                }

                if (scrollTopEnd > scrollTop && nowOffset >= scrollTopEnd) {
                    clearInterval(Interval)
                }

                if (scrollTopEnd < scrollTop && nowOffset <= scrollTopEnd) {
                    clearInterval(Interval)
                }
            }, interval_time);
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/CmTabs/index.vue